// The IPEDS reporting year always runs July 1 – June 30, so the list is system-defined and
// hard-coded rather than read from the Academic Year table. It is shared by every extract that
// reports on the IPEDS collection year; newest first, as the dropdown lists it.
export const FIRST_REPORTING_YEAR = 2023;
export const LAST_REPORTING_YEAR = 2040;

// Stored in the DateInput's own format, so a year's standard period and a hand-picked date
// compare and render the same way.
const toDateValue = (year, monthDay) => `${year}-${monthDay}T00:00:00`;

const buildReportingYear = (startYear) => ({
    id: startYear,
    span: `${startYear}–${String(startYear + 1).slice(-2)}`,
    startYear,
    endYear: startYear + 1,
    periodStart: toDateValue(startYear, '07-01'),
    periodEnd: toDateValue(startYear + 1, '06-30')
});

export const IPEDS_REPORTING_YEARS = Array.from(
    { length: LAST_REPORTING_YEAR - FIRST_REPORTING_YEAR + 1 },
    (_, index) => buildReportingYear(LAST_REPORTING_YEAR - index)
);

export const getReportingYear = (id) => IPEDS_REPORTING_YEARS.find((year) => year.id === id) || null;

/** "2024–25 (July 1, 2024 – June 30, 2025)" */
export const reportingYearLabel = (t, year) => t('ipedsWizard.reportingYearOption', {
    ns: 'tools',
    span: year.span,
    startYear: year.startYear,
    endYear: year.endYear
});
